import { render, staticRenderFns } from "./TemplatesForm.vue?vue&type=template&id=cc8ca1de"
import script from "./TemplatesForm.vue?vue&type=script&lang=js"
export * from "./TemplatesForm.vue?vue&type=script&lang=js"
import style0 from "./TemplatesForm.vue?vue&type=style&index=0&id=cc8ca1de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports